import { Button, PaperProps, Popover } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { SingleTextField } from "@saleor/components/SingleTextField";
import { makeStyles } from "@saleor/macaw-ui";
import React, { useState } from "react";
import { useIntl } from "react-intl";

interface PopoverProps {
  title: string;
  placeholder?: string;
  okText?: string;
  cancelText?: string;
  onOk: (value) => void;
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLButtonElement | null;
  regexInput?: RegExp;
  maxLengthInput?: number;
  id?: string;
  testId?: string;
}

const useStyles = makeStyles(
  () => ({
    actionRow: {
      display: "flex",
      alignItems: "center",
      gap: "2rem",
      marginTop: "2.4rem",
      "& .MuiButton-root": {
        width: "100%",
        height: 32
      }
    },

    root: {
      "& .MuiPopover-paper": {
        padding: "2.4rem",
        borderRadius: 16,
        width: 280
      }
    },
    titlePopover: {
      marginBottom: "2.4rem"
    }
  }),
  { name: "PopupApplyAll" }
);

const PopoverApplyAll: React.FC<PopoverProps> = props => {
  const {
    open,
    title,
    placeholder,
    okText,
    cancelText,
    onOk,
    anchorEl,
    onClose,
    regexInput,
    maxLengthInput,
    id,
    testId
  } = props;

  const [value, setValue] = useState<string>("");
  const classes = useStyles();
  const intl = useIntl();

  const handleChangeInput = value => {
    setValue(value.target.value);
  };

  const handleApply = () => {
    onOk(value);
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left"
      }}
      PaperProps={{
        ...({
          "data-testid": testId ?? "popoverApplyAll"
        } as Partial<PaperProps>)
      }}
      className={classes.root}
    >
      <MyTypography variant={"h6"} className={classes.titlePopover}>
        {title}
      </MyTypography>
      <SingleTextField
        onChange={handleChangeInput}
        value={value}
        placeholder={placeholder}
        maxLengthProps={maxLengthInput}
        regex={regexInput}
        id={id}
      />
      <div className={classes.actionRow}>
        <Button
          id="cancelPopUpApplyAll"
          data-testid="cancelPopUpApplyAll"
          variant={"outlined"}
          className={"defaultB"}
          onClick={onClose}
        >
          <MyTypography variant={"body3"}>
            {cancelText
              ? cancelText
              : intl.formatMessage({ defaultMessage: "ยกเลิก" })}
          </MyTypography>
        </Button>
        <Button
          id="summitPopUpApplyAll"
          data-testid="summitPopUpApplyAll"
          variant={"contained"}
          className={"defaultB"}
          onClick={handleApply}
        >
          <MyTypography variant={"body3"}>
            {okText
              ? okText
              : intl.formatMessage({ defaultMessage: "APPLY ALL" })}
          </MyTypography>
        </Button>
      </div>
    </Popover>
  );
};

export default PopoverApplyAll;
